// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z9Cj5","newExpiryDate":"styles_newExpiryDate__2GQ_o","footer":"styles_footer__1KeZ8"};